

// This file will probably move into cio-config and be shared between library.io and circuits editors
// So this file should not have any dependancies.  Functional programming only.

var ContentServerHelper = {};

// make a request to the CS
ContentServerHelper.request = function(requestMethod, requestURL, requestHeaders, data, sync, jsonResponseExpected) {
    var r = function(resolve, reject) {
        var dataType = jsonResponseExpected ? "json" : undefined;
        var request_obj = {
            "type": requestMethod,
            "headers": requestHeaders,
            "url": requestURL,
            "crossDomain": true,
            "xhrFields": {withCredentials: true},
            "dataType": dataType,
            "async": sync ? false : true,
            "processData": data instanceof FormData ? false : true,
            "contentType": data instanceof FormData ? false : undefined,
            "success": function(data) {
                if(resolve) resolve(data);
            },
            "error": function(xhr, textStatus, errorThrown) {
                var error = new Error(`Content server error: ${xhr["status"]}:"${xhr["statusText"]}", url: "${requestURL}", error: "${textStatus}"`);
                error["status"] = xhr["status"];
                error["responseText" ]= xhr["responseText"];

                if(reject) reject(error);
            }
        };
        if (data) {
            request_obj["data"] = data;
        }
        return $.ajax(request_obj);
    };
    if(sync) {
        var res = r();
        if(!ContentServerHelper.isOkStatus(res["status"])) {
            // got an error, return the error so it can be handled
            throw res;
        }

        if(jsonResponseExpected)
            return res['responseJSON'];
        else
            return res["responseText"];
    } else {
        // if async must catch error
        return new Promise(r);
    }
};

ContentServerHelper.isOkStatus = function(status) {
    if(Math.floor(status/100) == 2) return true;
    return false;
}






module.exports = ContentServerHelper;





